/**
 *
 * Modifies the ID prop of each heading to the a stringified version of the text
 *
 */
try{
  wp.domReady( ()=>{

    if( wp.hooks ){

      function AddBlockId( props, blockType ) {
        if(blockType.name === 'core/heading' && props.value) {

          var slug = (props.value)
            .toLowerCase()
            .trim()
            .replace( /[^\w\s-]/gi, '' )
            .replace(/ +/g,'-');

          return Object.assign( props, { id: slug} );

        }
        return props;
      }

      wp.hooks.addFilter(
        'blocks.getSaveContent.extraProps',
        'itbl-gutenberg/add-block-id',
        AddBlockId
      );

    }
  } );
}catch (e) {

}


